module.exports = __webpack_public_path__ + "static/media/fff-dark-circular.f08cff5a.png";